/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Split Screen directive options
 */
export const splitScreenOptions = {
  /**
   * Visibility threshold to determine active item (0-1)
   */
  threshold: 0.4,
  thresholdMobile: 0.9,

  /**
   * Mobile breakpoint in pixels
   */
  mobileBreakpoint: 1024,

  /**
   * Debounce delay for resize handler in milliseconds
   */
  resizeDebounce: 100,

  /**
   * Selectors
   */
  selectors: {
    // header: '.sticky-top', keep this when merge configurator-v2
    header: '.sticky-top, header >.fixed-top', // fix for old header, remove when merge configurator-v2
    item: '.common--split-screen-item, .split-screen-item',
    itemsContainer: '.split-screen__items',
    contentWrapper: '.split-screen-item__content-wrapper',
    mediaWrapper: '.split-screen-item__media-wrapper'
  }
};
